import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listReviewQueue, resolveReview } from './api';
import type { ReviewItem, ReviewResolution } from './types';

const KEY = ['manual-review'] as const;

export function useReviewQueue() {
  return useQuery<ReviewItem[]>({
    queryKey: KEY,
    queryFn: listReviewQueue,
    staleTime: 30_000,
  });
}

export function useResolveReview() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { reviewUrn: string; resolution: ReviewResolution }) =>
      resolveReview(input.reviewUrn, input.resolution),
    onSuccess: (_data, input) => {
      qc.setQueryData<ReviewItem[]>(KEY, (prev) =>
        (prev ?? []).filter((r) => r.reviewUrn !== input.reviewUrn),
      );
    },
  });
}
